export default function getLimitedList(array, quantity) {
  if (array.length > quantity) {
    return array.slice(0, quantity);
  } else {
    return array;
  }
}
